import BaseModel from './BaseModel'

export default class DocumentModel extends BaseModel {
  constructor(data: any, relation: any) {
    const fields = {
      DATE_DOCUMENT: ''
    }
    super(data, relation, fields)
  }
}
